import PropTypes from 'prop-types';
import { listing as listingType } from '../proptypes/index';
import { showRoute, getBadgeContent } from '../helpers/index';

const ListingTile = ({ listing, onClick }) => {
  const {
    slug,
    name,
    categories,
    properties,
    logo_url: logoUrl,
    short_description: shortDescription,
    discount_description: discountDescription,
    discount_url: discountUrl,
  } = listing;

  const invokeCallback = () => {
    onClick(slug);
  };

  const badgeContent = getBadgeContent(properties, categories);

  return (
    <a href={showRoute(slug)} className="listingTile" onClick={invokeCallback}>
      {!!badgeContent && <span className="badge">{badgeContent}</span>}

      <div className="flex">
        <div>
          <div className="logoContainer">
            <img src={logoUrl} alt={`${name} logo`} />
          </div>
        </div>

        <div>
          <h6>{name}</h6>

          <p>{shortDescription}</p>

          {discountDescription && discountUrl && (
            <div className="discountText">{discountDescription}</div>
          )}
        </div>
      </div>
    </a>
  );
};

ListingTile.propTypes = {
  listing: listingType.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ListingTile;
